// Auth store — persists the admin JWT in localStorage so a hard reload keeps
// the user logged in. We deliberately keep this tiny: the only thing that
// needs to survive a refresh is the token + minimal profile metadata. Full
// /me details are re-fetched on mount from the API.

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface AdminProfile {
  id: string;
  username: string;
  display_name?: string;
  /** Coarse role gates. Backend may evolve this list. */
  role?: 'super' | 'pm' | 'ops' | 'ml' | 'art' | 'growth';
  /** "admin" — present so a stray user token can't be reused here. */
  scope?: string;
}

interface AuthState {
  token: string | null;
  profile: AdminProfile | null;
  setAuth: (token: string, profile?: AdminProfile | null) => void;
  setProfile: (profile: AdminProfile | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      profile: null,
      setAuth: (token, profile) =>
        set({ token, profile: profile ?? null }),
      setProfile: (profile) => set({ profile }),
      clear: () => set({ token: null, profile: null }),
    }),
    {
      name: 'touliu-admin-auth',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ token: s.token, profile: s.profile }),
    },
  ),
);
